import React, { useEffect, useState } from "react";
import { apiGetOrgunits } from "../../../api/ApiOrgunit";
import { apiGetProcess, apiUpdateProcess } from "../../../api/ApiProcess";
import { BiHide, BiSubdirectoryRight } from "react-icons/bi";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ModalChoixResponsables = (props) => {
  const { t } = useTranslation();
  const { idProcess, ReduxInstanceId, show, handleClose } = props;
  const [orgunits, setOrgunits] = useState([]);
  const [processModal, setProcessModal] = useState("");
  const [isModified, setIsModified] = useState(false);

  const recupOrgunitsAndProcess = async () => {
    const resProcess = await apiGetProcess(ReduxInstanceId, idProcess);
    setProcessModal(resProcess.data);

    const resOrgunit = await apiGetOrgunits(ReduxInstanceId);
    if (resOrgunit) {
      setOrgunits(resOrgunit.data);
    }
  };

  const addRemoveOrgunit = async (idOrgunit) => {
    setIsModified(true);
    let orgunits = [...processModal.orgunits];
    if (orgunits.includes(idOrgunit)) {
      orgunits = orgunits.filter((item) => item !== idOrgunit);
    } else {
      orgunits.push(idOrgunit);
    }
    setProcessModal({ ...processModal, orgunits: orgunits });
  };

  const saveBeforeClose = async () => {
    if (isModified) {
      const formData = { orgunits: processModal.orgunits };
      await apiUpdateProcess(idProcess, formData);
    }
    handleClose();
  };

  useEffect(() => {
    if (show) {
      setIsModified(false);
      recupOrgunitsAndProcess();
    }
  }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

  const RecursiveComponentOrgUnit = ({ objet, childrens, niveau }) => {
    let hasChildren = false;
    if (childrens && childrens.length) hasChildren = true;

    return (
      <>
        <InputGroup className="">
          {niveau !== 0 && (
            <BiSubdirectoryRight
              size="1.5em"
              className={"text-danger"}
              style={{ marginLeft: niveau * 15 + "px" }}
            />
          )}
          <Form.Check
            role="button"
            id={"orgunit_" + objet._id}
            type="switch"
            label={
              <>
                {objet.enSommeil && (
                  <BiHide size="1.5em" className="orgunitAdminHiddenButton me-2" />
                )}
                {objet.nom}
              </>
            }
            value={objet._id}
            onChange={(e) => {
              addRemoveOrgunit(e.target.value);
            }}
            checked={processModal.orgunits.includes(objet._id) ? "checked" : ""}
          />
        </InputGroup>
        {hasChildren &&
          childrens.map((enfant) => (
            <RecursiveComponentOrgUnit
              key={enfant._id}
              objet={enfant}
              childrens={orgunits.filter((item) => item.orgUnitParent === enfant._id)}
              niveau={niveau + 1}
            />
          ))}
      </>
    );
  };

  return (
    <Modal show={show} onHide={saveBeforeClose}>
      <Modal.Header closeButton>
        <Modal.Title>
          {t("admin.PageAdminProcesses.modalResponsablesTitre")} {processModal.nom}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* ORGUNITS LEVEL 0 */}
        {orgunits
          .filter((orgunit) => orgunit.orgUnitParent === null)
          .map((orgunit) => (
            <RecursiveComponentOrgUnit
              key={orgunit._id}
              objet={orgunit}
              childrens={orgunits.filter((item) => item.orgUnitParent === orgunit._id)}
              niveau={0}
            />
          ))}
      </Modal.Body>
    </Modal>
  );
};

export default ModalChoixResponsables;
